import type { Trail } from "@hash/shared";
import { eventStartMs, isWithinCheckInWindow } from "@hash/shared";

// The hare landing window (Story 8.1) and the self check-in window (Story
// 13.1) are the same [start-12h, start+6h] interval; the canonical
// implementation lives in @hash/shared (logic.ts). Re-exported here under the
// hare-flow name for the picker/landing callers.
export { eventStartMs };
export const isWithinHareWindow = isWithinCheckInWindow;

/**
 * Trails where the hasher is a hare and now is within the window, sorted by
 * proximity to the scheduled start (closest first, regardless of past/future) —
 * the order Story 8.1 wants for the multi-match list.
 */
export function hareWindowMatches(
  trails: Trail[],
  hasherId: string,
  nowMs: number
): Trail[] {
  return trails
    .filter(
      (t) =>
        t.hareHasherIds?.includes(hasherId) && isWithinHareWindow(t, nowMs)
    )
    .sort((a, b) => {
      const da = Math.abs(nowMs - (eventStartMs(a) ?? 0));
      const db = Math.abs(nowMs - (eventStartMs(b) ?? 0));
      return da - db;
    });
}
